import { useNavigate } from "react-router-dom";
import { decodeHtmlEntities } from "constant/htmlEntities";
import PaymentService from "services/PaymentService";
import { formatToLocalDateString } from "utils/timeFunctions";
import { FaLock } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";

const PaymentModal = ({ ppv_event }: any) => {
  console.log(ppv_event);
  const navigate = useNavigate();

  const handlePaymentProcess = async (e: any) => {
    navigate("/ppv/checkout", { state: { ppv_event } });
  };

  const finalServiceFee =
    parseFloat(ppv_event?.price) * (parseFloat(ppv_event?.service_fee) / 100);

  const finalDiscount =
    parseFloat(ppv_event?.price) * (parseFloat(ppv_event?.discount) / 100);

  const totalFee =
    parseFloat(ppv_event?.price) + finalServiceFee - finalDiscount;

  const clean = (value: string) => decodeHtmlEntities(value);

  return (
    <>
      <div className="">
        <div
          className="relative my-2 overflow-hidden rounded-2xl"
          // main back image
          style={{
            color: "#fff",
            backgroundImage: `url(${ppv_event?.bannerImage})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "650px",
          }}
        >
          <div className="font-rubik scrollbar-hide absolute right-0 flex h-[700px] w-[50%] flex-col overflow-hidden rounded-2xl bg-white max-sm:w-full">
            <div className="scrollbar-hide flex h-full flex-col overflow-y-auto p-8 max-sm:px-5 max-sm:pt-[100px]">
              {/* Event */}
              <h1 className="text-[24px] font-bold leading-tight tracking-tight text-gray-900">
                {clean(ppv_event?.title)}
              </h1>

              <p className="scrollbar-hide my-4 max-h-[84px] overflow-y-auto text-[14px] leading-relaxed text-gray-500">
                {ppv_event?.description?.length > 190
                  ? `${clean(ppv_event?.description).slice(0, 190)}...`
                  : clean(ppv_event?.description)}
              </p>

              {/* Date / rent pill */}
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 text-[13px] font-semibold text-white shadow-md shadow-red-600/30">
                  <FiCalendar className="text-[14px]" />
                  {ppv_event?.category === "Movie"
                    ? `Available for Rent: ${ppv_event?.rent_duration} Days`
                    : formatToLocalDateString(ppv_event?.event_formatted_date)}
                </span>
              </div>

              {/* Payment summary */}
              <h2 className="mt-8 text-[18px] font-bold text-gray-900">
                Payment
              </h2>

              <div className="mt-4 rounded-2xl border border-gray-100 bg-gray-50 p-5">
                <div className="flex justify-between">
                  <span className="text-[15px] font-medium text-gray-500">
                    Sub Total
                  </span>
                  <span className="text-[15px] font-semibold text-gray-800">
                    {"£"}
                    {ppv_event?.price}
                  </span>
                </div>
                <div className="mt-3 flex justify-between">
                  <span className="text-[15px] font-medium text-gray-500">
                    Service Fee
                  </span>
                  <span className="text-[15px] font-semibold text-gray-800">
                    {ppv_event?.service_fee}
                    {"%"}
                  </span>
                </div>
                <div className="mt-3 flex justify-between">
                  <span className="text-[15px] font-medium text-gray-500">
                    Discount
                  </span>
                  <span className="text-[15px] font-semibold text-gray-800">
                    {ppv_event?.discount}
                    {"%"}
                  </span>
                </div>
                <hr className="my-4 h-px border-0 bg-gray-200" />
                <div className="flex items-center justify-between">
                  <span className="text-[18px] font-extrabold text-gray-900">
                    Total
                  </span>
                  <span className="text-[22px] font-extrabold text-gray-900">
                    {"£"}
                    {totalFee.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* CTA */}
              <div className="mt-6 w-full">
                <button
                  className="flex w-full items-center justify-center gap-2 rounded-full bg-red-600 px-5 py-3.5 shadow-lg shadow-red-600/30 transition-all duration-300 hover:scale-[1.01] hover:brightness-110 hover:shadow-xl"
                  onClick={handlePaymentProcess}
                >
                  <FaLock className="text-[14px] text-white" />
                  <span className="text-[18px] font-semibold text-white max-lg:text-[15px]">
                    Complete Payment {"£"}
                    {totalFee.toFixed(2)}
                  </span>
                </button>
                <p className="mt-3 flex items-center justify-center gap-1.5 text-[12px] text-gray-400">
                  <FaLock className="text-[10px]" />
                  Secure payment powered by Stripe
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentModal;